import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Seo from "@/components/Seo";

const DEEP = /^\/(my-classes|assignment)\/[A-Za-z0-9_-]{1,64}$|^\/my-classes$/;

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const { pathname } = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="w-12 h-12 border-4 border-ink border-t-coral rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to={DEEP.test(pathname) ? `/login?next=${encodeURIComponent(pathname)}` : "/login"} replace />;
  return <><Seo noindex />{children}</>;
}
